import { useRef, useState } from "react";

const UserLocationReadOnlyRow = ({ key, t, userLocationItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userLocationItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userLocationItem, submitComplete);
	}

	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userLocationItem.departmentName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userLocationItem.locationName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userLocationItem.address}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userLocationItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, userLocationItem)}>
					{userLocationItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default UserLocationReadOnlyRow;